import React,{useState} from "react"
import Logo from '../images/logo.png'
import "../styles/style.css"

const Header = () => {

  const [nav,setNav] = useState(false)

  const navHandler = () => setNav(!nav)

  return <header>
    <div className="wrap">
      <a href="http://f22labs.com"><img src={Logo} alt="logo" className="logo" /></a> 
      <button className="breadcrumb" onClick={navHandler}><i className="mdi mdi-menu"></i></button>
      <div className={nav? 'nav' : 'nav hide'}>
        <a href="http://f22labs.com/#About">About</a>
        <a href="http://f22labs.com/#Work">Work</a>
        <a href="http://f22labs.com/team">Team</a>
        <a href="http://f22labs.com/events">Events</a>
        <a href="http://f22labs.com/#contact">Contact</a>
        <a href="https://f22labs.zohorecruit.com/recruit/Portal.na?digest=ytFbIidbchfNDprQRrm5xXGAUnkE7bVo.a85bxdBEmQ-">Career</a>
        <a href="http://f22labs.com/apply-for-intern">Internship</a>
      </div>
    </div>
  </header>
}

export default Header